import PropTypes from 'prop-types';

import Heading from 'shopper/components/Heading';
import Text from 'shopper/components/Text';

import placeholder from 'lib/placeholder';

import Card from './Card';
import QrCode from './QrCode';

const DownloadApp = ({ gaEventCategory }) => (
  <section className="relative mb-16 h-60 rounded-4 bg-gradient-to-br from-[#000] via-[#000] to-[#0E58A9] px-10 drop-shadow-2xl md:mb-0 md:mt-16 md:flex md:h-52">
    <Card gaEventCategory={gaEventCategory} />
    <div className="ml-auto mr-0 hidden w-2/3 flex-row items-center justify-end gap-x-5 md:flex">
      <div>
        <Heading
          as="h2"
          className="text-neutral-high-100 dark:text-neutral-high-100"
          size="size2"
        >
          {placeholder('titles.bfDownload')}
        </Heading>
        <Text
          className="mt-2 text-neutral-high-100 dark:text-neutral-high-100"
          size="size1"
        >
          {placeholder('subtitles.bfDownloadApp')}
        </Text>
      </div>
      <QrCode />
    </div>
  </section>
);

DownloadApp.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
};

export default DownloadApp;
